import axios from "@/plugins/axios";
import store from "@/store";

async function apiGetUser() {
  return new Promise((resolve) => {
    axios.post("?Mode=General&Function=GetUser").then((response) => {
      if (response.data.Status === "Success" && response.data.Result) {
        store.commit("setUser", response.data.Result);
        resolve();
      }
    });
  });
}

async function apiAddUserTag(tag) {
  return axios.post("?Mode=General&Function=AddUserTag", {
    Tag: tag,
  });
}

async function apiRemoveUserTag(tag) {
  return axios.post("?Mode=General&Function=RemoveUserTag", {
    Tag: tag,
  });
}

async function apiGetCases() {
  return new Promise((resolve) => {
    axios.post("?Mode=General&Function=GetCases").then((response) => {
      if (response.data.Status === "Success" && response.data.Result) {
        store.commit("setCases", response.data.Result);
        resolve();
      }
    });
  });
}

async function apiDeleteDoctor(data) {
  return axios.post("?Mode=General&Function=DeleteDoctor", data);
}

export {
  apiGetUser,
  apiAddUserTag,
  apiRemoveUserTag,
  apiGetCases,
  apiDeleteDoctor,
};
